import store from './store'

let timer = 0

/*
cardColors: {
      ACCEPTED: '#127bc4',
      COMPLETED: '#d36b00',
      APPROVED: '#009654',
      REJECTED: '#db4437',
      PENDING: '#c6a213',
      EXPIRED: '#814193',
      ACTIVE: '#782b54',
      UPLOADED: '#009654',
      STARTED: '#782b54',
      ATTENTION: '#009654'
    }
    */
export default function (Vue: any) {
  Vue.common = {
    cardColors: {
      ACCEPTED: '#c6a213',
      COMPLETED: '#d36b00',
      APPROVED: '#BDA340',
      REJECTED: '#757575',
      PENDING: '#782b54', // Older - #692093
      EXPIRED: '#757575',
      ACTIVE: '#782b54',
      UPLOADED: '#009654',
      STARTED: '#db4437',
      ATTENTION: '#cb4f40'
    },
    statusSortOrder: {
      ACCEPTED: 'updated_at-ASC',
      COMPLETED: 'updated_at-ASC',
      APPROVED: 'updated_at-DESC',
      REJECTED: 'updated_at-DESC',
      PENDING: 'id-ASC',
      ATTENTION: 'updated_at-DESC',
      EXPIRED: 'expire_date_time-DESC'
    },

    getDefaultImage (type: string) {
      switch (type) {
        default:
          return '/img/pickl-logo.png'
      }
    },

    changeDefaultImage (event: Event, type: string) {
      if (event && event.target && event.target instanceof HTMLImageElement) event.target.src = this.getDefaultImage(type)
    },

    encodeData (data: { [key: string]: string }) {
      return Object.keys(data)
        .map(function (key) {
          return [key, data[key]].map(encodeURIComponent).join('=')
        })
        .join('&')
    },
    delay (callback:Function, ms:any) {
      return () => {
        let context = this
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          callback.apply(context)
        }, ms || 0)
      }
    },
    getStatusTitle (status: string) {
      switch (status.trim()) {
        case 'COMPLETED':
          // if (store.state.userData && store.state.userData.role === 'super-admin') return 'Awaiting Approval'
          // else
          return 'Awaiting Approval'
        case 'PENDING':
          return 'Launched  Activities'
        case 'ATTENTION':
          return 'Attention Needed'
        default:
          return status.toLowerCase() + ''
      }
    }
  }

  Object.defineProperties(Vue.prototype, {
    $common: {
      get () {
        return Vue.common
      }
    }
  })
}
